module.exports = __webpack_public_path__ + "static/backpack-49260bcf44516121e13989b73c1c1e58.png";